/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE and NOTICE files at the root of the source
 * tree and available online at
 *
 * http://www.dspace.org/license/
 */
import {
  deserializeAs,
  inheritSerialization,
} from 'cerialize';
import { Observable } from 'rxjs';

import {
  inheritLinkAnnotations,
  link,
  typedObject,
} from '../../cache/builders/build-decorators';
import { IDToUUIDSerializer } from '../../cache/id-to-uuid-serializer';
import { PaginatedList } from '../../data/paginated-list.model';
import { RemoteData } from '../../data/remote-data';
import { ResourceType } from '../../shared/resource-type';
import { EditItemMode } from './edititem-mode.model';
import { SubmissionObject } from './submission-object.model';

/**
 * Represents the object type of the edit submission object.
 *
 * Used to map responses from {@link EditItemDataService} wich is used to retrieve available edit modes for a given item.
 * {@link EditItemMenuProvider}.
 */
@typedObject
@inheritSerialization(SubmissionObject)
@inheritLinkAnnotations(SubmissionObject)
export class EditItem extends SubmissionObject {
  static type = new ResourceType('edititem');

  /**
   * The universally unique identifier of this WorkspaceItem
   * This UUID is generated client-side and isn't used by the backend.
   * It is based on the ID, so it will be the same for each refresh.
   */
  @deserializeAs(new IDToUUIDSerializer(EditItem.type.value), 'id')
    uuid: string;

  /**
   * Existing EditItem modes for current EditItem
   * Will be undefined unless the modes {@link HALLink} has been resolved.
   */
  @link(EditItemMode.type)
    modes?: Observable<RemoteData<PaginatedList<EditItemMode>>>;
  /**
   * Existing EditItem modes for current EditItem
   * Will be undefined unless the modes {@link HALLink} has been resolved.
   */
  @link(EditItemMode.type)
    edititemmodes?: Observable<RemoteData<PaginatedList<EditItemMode>>>;
}
